export default function CupIco({ filled = false, fill = "#FFB300" }) {
  return !filled ? (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_556_15443)">
        <path
          d="M3.625 8.85714C3.625 5.41523 6.41523 2.625 9.85714 2.625H36.1429C39.5848 2.625 42.375 5.41523 42.375 8.85714V35.1429C42.375 38.5848 39.5848 41.375 36.1429 41.375H9.85714C6.41523 41.375 3.625 38.5848 3.625 35.1429V8.85714Z"
          stroke="#EAECF0"
          stroke-width="1.25"
          shape-rendering="crispEdges"
        />
        <path
          d="M23 24.3889V27.2222M23 24.3889C20.8498 24.3889 19.0563 22.7665 18.6445 20.6111M23 24.3889C25.1502 24.3889 26.9437 22.7665 27.3556 20.6111M23 27.2222C23.8267 27.2222 24.24 27.2222 24.5791 27.3187C25.4993 27.5807 26.2181 28.3445 26.4647 29.3222C26.5556 29.6825 26.5556 30.1217 26.5556 31H19.4444C19.4444 30.1217 19.4444 29.6825 19.5353 29.3222C19.7819 28.3445 20.5007 27.5807 21.4209 27.3187C21.76 27.2222 22.1733 27.2222 23 27.2222ZM18.6445 20.6111H18.5556H18.3333C17.7138 20.6111 17.404 20.6111 17.1464 20.5567C16.0886 20.3331 15.2617 19.4545 15.0512 18.3305C15 18.0568 15 17.7277 15 17.0694C15 16.85 15 16.7403 15.0171 16.6491C15.0872 16.2744 15.3629 15.9816 15.7155 15.907C15.8013 15.8889 15.9046 15.8889 16.1111 15.8889H18.5556M18.6445 20.6111C18.5862 20.306 18.5556 19.9901 18.5556 19.6667V15.4841C18.5556 14.9806 18.5556 14.7289 18.6436 14.5347C18.731 14.3419 18.8773 14.1864 19.0588 14.0935C19.2416 14 19.4785 14 19.9524 14H26.0476C26.5215 14 26.7584 14 26.9412 14.0935C27.1227 14.1864 27.2691 14.3419 27.3564 14.5347C27.4444 14.7289 27.4444 14.9806 27.4444 15.4841V19.6667C27.4444 19.9901 27.4139 20.306 27.3556 20.6111M27.3556 20.6111H27.4444H27.6667C28.2862 20.6111 28.596 20.6111 28.8536 20.5567C29.9114 20.3331 30.7383 19.4545 30.9488 18.3305C31 18.0568 31 17.7277 31 17.0694C31 16.85 31 16.7403 30.9829 16.6491C30.9128 16.2744 30.6372 15.9816 30.2845 15.907C30.1987 15.8889 30.0954 15.8889 29.8889 15.8889H27.4444"
          stroke="#344054"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_556_15443"
          x="0.5"
          y="0.75"
          width="45"
          height="45"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.25" />
          <feGaussianBlur stdDeviation="1.25" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_556_15443"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_556_15443"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  ) : (
    <svg
      width="40"
      height="40"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.625 8.857a6.23 6.23 0 0 1 6.232-6.232h26.286a6.23 6.23 0 0 1 6.232 6.232v26.286a6.23 6.23 0 0 1-6.232 6.232H9.857a6.23 6.23 0 0 1-6.232-6.232z"
        stroke="#EAECF0"
        strokeWidth="1.25"
        shapeRendering="crispEdges"
        fill="#FFFFFF"
      />
      <g transform="translate(11, 9) scale(1.5)">
        <path
          d="M14.5 3H12V2.5C12 2.2 11.8 2 11.5 2H4.5C4.2 2 4 2.2 4 2.5V3H1.5C1.2 3 1 3.2 1 3.5V4.85C1 7.05 2.7 8.85 4.9 8.95C5.3 9.5 5.85 9.9 6.5 10.15V11.5H6C5.15 11.5 4.5 12.15 4.5 13V14.5C4.5 14.8 4.7 15 5 15H11C11.3 15 11.5 14.8 11.5 14.5V13C11.5 12.15 10.85 11.5 10 11.5H9.5V10.2C10.15 9.95 10.7 9.5 11.1 9C13.25 8.85 15 7.1 15 4.9V3.5C15 3.2 14.8 3 14.5 3ZM2 4.85V4H4V6.5C4 7 4.1 7.45 4.25 7.85C2.95 7.5 2 6.3 2 4.85ZM14 4.85C14 6.25 13.05 7.45 11.75 7.85C11.9 7.45 12 7 12 6.5V4H14V4.85Z"
          fill={fill}
        />
      </g>
    </svg>
  );
}
